import React from 'react';
import { FaLock } from 'react-icons/fa';
import LicenseActivationPanel from '../components/LicenseActivationPanel';

// Full-page lock shown to anyone but Super Admin when the license gate
// blocks a request (missing/expired/wrong-server key) — see the 402
// interceptor in services/api.js. The license key can be entered right here
// (LicenseActivationPanel); a Super Admin can also sign in and activate it
// from Commercial Setup -> License.
const LicenseLocked = () => {
  const message = sessionStorage.getItem('licenseBlockMessage') || 'This application is not licensed on this server.';

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg-color, #f8fafc)', padding: '24px' }}>
      <div style={{ maxWidth: '480px', textAlign: 'center', background: 'var(--card-bg, #fff)', border: '1px solid var(--border-color, #e5e7eb)', borderRadius: '12px', padding: '32px 28px' }}>
        <FaLock style={{ fontSize: '36px', color: 'var(--danger-color, #dc2626)', marginBottom: '12px' }} />
        <h2 style={{ margin: '0 0 10px', fontSize: 'var(--fs-xl)' }}>Application Locked</h2>
        <p style={{ color: 'var(--text-secondary)', fontSize: 'var(--fs-md)', margin: '0 0 20px' }}>{message}</p>
        <LicenseActivationPanel onActivated={() => window.location.replace('/login')} />
        <a href="/login" style={{ fontSize: 'var(--fs-md)' }}>Back to sign-in</a>
      </div>
    </div>
  );
};

export default LicenseLocked;
